"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistantMessageFeedback = exports.AssistantMessageRole = void 0;
var AssistantMessageRole;
(function (AssistantMessageRole) {
    AssistantMessageRole["SYSTEM"] = "system";
    AssistantMessageRole["CONTEXT"] = "context";
    AssistantMessageRole["USER"] = "user";
    AssistantMessageRole["ASSISTANT"] = "assistant";
})(AssistantMessageRole || (exports.AssistantMessageRole = AssistantMessageRole = {}));
var AssistantMessageFeedback;
(function (AssistantMessageFeedback) {
    AssistantMessageFeedback["POSITIVE"] = "positive";
    AssistantMessageFeedback["NEGATIVE"] = "negative";
})(AssistantMessageFeedback || (exports.AssistantMessageFeedback = AssistantMessageFeedback = {}));
//# sourceMappingURL=assistant-conversation.types.js.map